import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_coupon_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    voucher_code_guid: fromDatatype.GuidDataFieldInterface;
    voucher_code: fromDatatype.VarcharDatatypeInterface;
    voucher_code_error: fromDatatype.VarcharDatatypeInterface;
    serial_number: fromDatatype.VarcharDatatypeInterface;
    serial_number_error: fromDatatype.VarcharDatatypeInterface;
    soft_pin: fromDatatype.VarcharDatatypeInterface;
    validity_status: fromDatatype.VarcharDatatypeInterface;
    assignment_status: fromDatatype.VarcharDatatypeInterface;
    redemption_status: fromDatatype.VarcharDatatypeInterface;
    cancellation_status: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.NumericDatatypeInterface;
    validated: fromDatatype.VarcharDatatypeInterface;
    processed: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    property_json: any;
    acl_policy: any;
    acl_config: any;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_coupon_import_file_helper_RowClass implements bl_fi_mst_coupon_import_file_helper_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
  voucher_code_guid: fromDatatype.GuidDataFieldInterface;
  voucher_code: fromDatatype.VarcharDatatypeInterface;
  voucher_code_error: fromDatatype.VarcharDatatypeInterface;
  serial_number: fromDatatype.VarcharDatatypeInterface;
  serial_number_error: fromDatatype.VarcharDatatypeInterface;
  soft_pin: fromDatatype.VarcharDatatypeInterface;
  validity_status: fromDatatype.VarcharDatatypeInterface;
  assignment_status: fromDatatype.VarcharDatatypeInterface;
  redemption_status: fromDatatype.VarcharDatatypeInterface;
  cancellation_status: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  short_error_message: fromDatatype.TextDatatypeInterface;
  error_stack_trace: fromDatatype.TextDatatypeInterface;
  line_number: fromDatatype.NumericDatatypeInterface;
  validated: fromDatatype.VarcharDatatypeInterface;
  processed: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_policy: any;
  acl_config: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
